import * as Html from "../../util/Html.ts";

export {initDom}

Html.registerWidget('widget/form/focusme',{
  initDom: initDom
})

function initDom(obj: HTMLElement){
  obj.focus();
}